/* eslint-disable @typescript-eslint/no-empty-function */

interface CbWindow extends Window {
  _dlf: Record<string, unknown>;
  CookieConsent: Record<string, unknown>;
  CookieControl: any;
  ga: any;
  gtag: any;
}

declare let window: CbWindow;

const fixLocale = (initialLocale: string) => {
  const split = initialLocale.split('_');

  return split[0];
};

const cookieBot = (locale = 'lt') => {
  locale = fixLocale(locale);

  if (window.location.hash.indexOf('__nocmp') !== -1 || (window._dlf && window._dlf.is_app_in_review)) {
    return;
  }

  // Append CB configuration script
  const c = window.document.createElement('script');
  c.id = 'CookiebotConfiguration';
  c.type = 'application/json';
  c.setAttribute('data-cookieconsent', 'ignore');
  c.innerHTML = JSON.stringify({
    Frameworks: {
      IABTCF2: {
        VendorRestrictions: [
          {
            VendorId: 1066,
            DisallowPurposes: [1, 2, 3, 4, 7, 10],
          },
        ],
      },
    },
  });

  window.document.getElementsByTagName('head')[0].appendChild(c);

  const e = window.document.createElement('script');
  e.id = 'Cookiebot';
  e.src = 'https://consent.cookiebot.com/uc.js';
  e.async = true;
  e.onload = function() {
    if (!window.CookieConsent) {
      return;
    }

    window.CookieConsent.removeCookies = function() {};
    window.CookieConsent.resetCookies = function() {};
  };
  e.setAttribute('data-cbid', '94f8d4f0-08f1-484b-861b-8a57bf9ed5af');
  e.setAttribute('data-framework', 'IAB');
  e.setAttribute('data-culture', locale);
  e.setAttribute('data-wipe-preferences', '0');
  e.setAttribute('data-wipe-statistics', '0');
  e.setAttribute('data-wipe-marketing', '0');
  document.getElementsByTagName('head')[0].appendChild(e);

  function optInVendors() {
    const vendors = [50, 328, 412, 755];
    for (let v = 0; v < vendors.length; v++) {
      const element = document.querySelector('input[data-iabvendorid="' + vendors[v] + '"]') as HTMLInputElement;
      element.checked = true;
    }
  }

  function requestNotifications() {
    try {
      // Check for PushManager and Notification support
      if ('PushManager' in window === false || 'Notification' in window === false) {
        return;
      }

      // Skip for Delfi mobile apps
      if (navigator.userAgent.indexOf('EmbeddedBrowser ') === -1) {
        return;
      }

      const pathName = window.location.pathname;
      if (window.location.hostname === 'www.delfi.lt' && !/ru/gi.test(pathName) && !/en/gi.test(pathName) && !/pl/gi.test(pathName)) {
        if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
          Notification.requestPermission().then(function(permission) {
            if (window.gtag) {
              window.gtag('event', 'webPushAskForPermission', { event_category: 'Push', event_label: permission === 'granted' ? 'Success' : 'Fail' });
            } else if (window.ga) {
              window.ga('send', 'event', 'Push', 'webPushAskForPermission', permission === 'granted' ? 'Success' : 'Fail');
            }
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  window.addEventListener('CookiebotOnDialogInit', function() {
    window.CookieControl.Dialog.prototype.IABDeselectVendors = function(exemptLegInt: any) {
      const IABelements = document.getElementsByClassName('CybotCookiebotDialogBodyIABButtonVendors');
      for (let i = 0; i < IABelements.length; i++) {
        const IABelement = IABelements[i] as HTMLInputElement;
        IABelement.checked = false;
        if (!exemptLegInt) {
          const IABelements = document.getElementsByClassName('CybotCookiebotDialogBodyIABButtonVendorsLegitimateInterestSelection');
          for (let j = 0; j < IABelements.length; j++) {
            const IABelement = IABelements[j] as HTMLInputElement;
            IABelement.checked = false;
          }
        }
      }

      optInVendors();
    };
  });

  window.addEventListener('CookiebotOnDialogDisplay', optInVendors);
  window.addEventListener('CookiebotOnAccept', requestNotifications);
  window.addEventListener('CookiebotOnDecline', requestNotifications);

  setTimeout(function() {
    const buttons = document.querySelectorAll('.CybotCookiebotDialogBodyButton');
    for (let b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', function(event: Event) {
        optInVendors();

        const eventTarget = event.target as HTMLElement;
        if (window.gtag) {
          window.gtag('event', 'CookieConsentDialog', { event_category: 'CookieConsent', event_label: eventTarget.id });
        } else if (window.ga) {
          window.ga('send', 'event', 'CookieConsent', 'CookieConsentDialog', eventTarget.id);
        }

        setTimeout(function() {
          window.gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            functionality_storage: 'granted',
            personalization_storage: 'granted',
            security_storage: 'granted',
          });
        }, 3000);
      });
    }
  }, 1000);

  setTimeout(function() {
    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted',
      security_storage: 'granted',
    });
  }, 3000);
};

export default cookieBot;
